import { render, staticRenderFns } from "./ModoPagoStep.vue?vue&type=template&id=ccad622a"
import script from "./ModoPagoStep.vue?vue&type=script&lang=js"
export * from "./ModoPagoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports